module.exports = __webpack_public_path__ + "img/pdf.2d7c057b.png";